import { Component, OnInit, Input, AfterViewInit, ViewEncapsulation, OnChanges, SimpleChanges, ElementRef, ViewChild } from '@angular/core';
import { CodeCheckBoxListModel } from './code-check-box-list.model';
import { GetCodeListService } from '../../combo-box/code-combo-box/api-services/get-code-list.service';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';

/**
 * コード定義チェックボックスリストクラス
 *
 * @export
 * @class CodeCheckBoxListComponent
 * @implements {OnInit}
 * @implements {AfterViewInit}
 */
@Component({
  selector: 'app-code-check-box-list',
  templateUrl: './code-check-box-list.component.html',
  styleUrls: ['./code-check-box-list.component.scss'],
  providers: [
    {
      provide: GetCodeListService,
      useFactory: (plessHttp: PlessHttp, dialogService: PlessDialogServiceSub) => {
        return new GetCodeListService(plessHttp, dialogService);
      },
      deps: [PlessHttp, PlessDialogServiceSub]
    }
  ],
  encapsulation: ViewEncapsulation.None,
})
export class CodeCheckBoxListComponent implements OnInit, AfterViewInit, OnChanges {

  /* データ連携用リスト flexは super.data |selectedValue|CodeValue|CodeDiv|などを持つ */
  public codeList: any[] = [];

  /* FlexのUI再現のため 最後にクリックされたIDを取得 */
  public lastClickId: string = <string>'';

  /* モデルインスタンス化 */
  public codeCheckBoxListModel = new CodeCheckBoxListModel();

  @ViewChild('list', { static: true }) public list: ElementRef;

  @Input() public subid: string = null;
  /* 位置調整用のパラメーター */
  @Input() left: number = <number>0;
  @Input() top: number = <number>0;
  @Input() width: number | string;
  @Input() height: number | string;

  @Input() tabindex: number = <number>0;
  /* コードマスタ取得用パラメーター */
  @Input() public codeDiv: string = <string>'';                                 // コード区分
  @Input() public reserveNum1: string = <string>'';

  /* そのほかパラメーター */
  @Input() public invalidCode: string = <string>'';                             // 画面に表示させないコード
  @Input() public initFocusItem: string = <string>'';                           // ロード完了後フォーカスを移動させるid
  @Input() forcedEnabledMode: string = null;
  /** 活性判定 */
  @Input() disabled: boolean = <boolean>false;

  /**
   * コンストラクタ
   *
   * @param {CodeCheckBoxListService} codeCheckBoxListService
   * @memberof CodeCheckBoxListComponent
   */
  constructor(
    public getCodeListService: GetCodeListService,
    public elementRef: ElementRef,
  ) { }

  /**
   * 値変更時イベント
   *
   * @param {SimpleChanges} changes 変更イベント
   * @memberof CodeCheckBoxListComponent
   */
  ngOnChanges(changes: SimpleChanges): void {
    Object.keys(changes).forEach((propName) => {
      switch (propName) {
        case 'invalidCode':
          // 先頭空白表示フラグ
          this.codeCheckBoxListModel.invalidCode = changes.invalidCode.currentValue;
          break;
      }
    });
  }

  /**
   * 初期処理
   *
   * @memberof CodeCheckBoxListComponent
   */
  ngOnInit(): void {
    // 自身をモデルに入れる
    this.codeCheckBoxListModel.codeListUI = this;
    this.list.nativeElement.setAttribute('id', this.subid + '_sub');
    this.list.nativeElement.setAttribute('forcedEnabledMode', this.forcedEnabledMode);
  }

  /**
   * ロード完了時
   *
   * @memberof CodeCheckBoxListComponent
   */
  ngAfterViewInit(): void {
    // データ取得
    this.getData();
  }


  /**
   * バインドの更新
   *
   * @param {string} itemCode // UI用最後にクリックされた箇所を取得する
   * @memberof CodeCheckBoxListComponent
   */
  public onChange(itemCode: string): void {
    // クリックされたIDをlastClickIdに保持し、html側のIDと同じ場合色付けする
    this.lastClickId = itemCode;

    // 自身のListに反映させる
    this.codeList = this.codeCheckBoxListModel.codeList;

  }

  /**
   * 選択コードNameを切り替える
   * codeValueのコードをチェックONにして、それ以外のコードをチェックOFFにする
   *
   * @param {string} codeValue // コード値
   * @memberof CodeCheckBoxListComponent
   */
  public setCodeValue(codeValue: string): void {
    this.codeCheckBoxListModel.setCodeValue = codeValue;

    // ロード完了の場合
    if (this.codeCheckBoxListModel.completeUpdateCodeList) {
      this.updateSelectedCodeValue();
    }
  }

  /**
   * コンボボックスの選択コードNameを切り替える
   *
   * @memberof CodeCheckBoxListComponent
   */
  public updateSelectedCodeValue(): void {
    if (this.codeCheckBoxListModel.setCodeValue != null) {
      let codeList: any[] = [];
      codeList = this.codeCheckBoxListModel.codeList;
      for (let i: any = 0; i < codeList.length; i++) {
        if (codeList[i].CodeValue === this.codeCheckBoxListModel.setCodeValue) {
          this.codeCheckBoxListModel.codeList[i].selectedValue = true;
        } else {
          this.codeCheckBoxListModel.codeList[i].selectedValue = false;
        }
      }
    }

    // バインドフィールドを更新
    this.onChange(null);
  }

  /**
   * リストの選択コードNameを切り替える
   *
   * @param {string} code
   * @param {boolean} chk
   * @memberof CodeCheckBoxListComponent
   */
  public updateCheckCodeValue(code: string, chk: boolean): void {
    setTimeout(() => {
      if (code === null) {
        let codeList = [];
        codeList = this.codeCheckBoxListModel.codeList;

        for (let i: any = 0; i < codeList.length; i++) {
          this.codeList[i].selectedValue = chk;
        }
      } else {
        const codeList = this.codeCheckBoxListModel.codeList;
        for (let i: any = 0; i < codeList.length; i++) {
          if (codeList[i].CodeValue.trim() === code) {
            this.codeList[i].selectedValue = chk;
          }
        }
      }
    }, 1000);
  }

  /**
   * コード更新完了 渡されたID属性へ遷移する
   *
   * @memberof CodeCheckBoxListComponent
   */
  public updateListComplete(): void {
    if (this.initFocusItem != null) {
      document.getElementById(this.initFocusItem).focus();
    }
  }

  /**
   * データ読み込み
   *
   * @memberof CodeCheckBoxListComponent
   */
  public getData(): void {
    // サービスのメソッドを実行
    this.getCodeListService.execute(this.codeCheckBoxListModel, this.codeDiv, this.reserveNum1, null);
  }
}
